function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "rating-pg_svg__a",
  d: "M.1 0h89.7v79.999H.1z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "rating-pg_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#rating-pg_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M87.545 75.094a6.936 6.936 0 01-6.066 3.503H8.52a6.936 6.936 0 01-6.066-3.502 6.939 6.939 0 01-.001-7.006l36.48-63.183A6.933 6.933 0 0145 1.404c2.532 0 4.8 1.309 6.066 3.502l36.479 63.183a6.93 6.93 0 010 7.005m1.215-7.707L52.28 4.204A8.323 8.323 0 0045 0a8.323 8.323 0 00-7.281 4.203L1.239 67.388a8.326 8.326 0 000 8.408 8.325 8.325 0 007.282 4.203h72.958a8.321 8.321 0 007.28-4.203 8.325 8.325 0 000-8.41",
  fill: "#000",
  mask: "url(#rating-pg_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.478 75.087H8.52c-2.69 0-4.372-2.913-3.027-5.243L41.973 6.66a3.463 3.463 0 013.026-1.747c1.177 0 2.355.582 3.028 1.747l36.478 63.184c1.346 2.33-.336 5.243-3.027 5.243m6.066-6.998L51.066 4.905A6.937 6.937 0 0045 1.403a6.936 6.936 0 00-6.066 3.502L2.454 68.09a6.934 6.934 0 00.001 7.006 6.932 6.932 0 006.065 3.502h72.958a6.933 6.933 0 006.066-3.503 6.93 6.93 0 000-7.005",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.027 6.66A3.464 3.464 0 0045 4.915a3.463 3.463 0 00-3.028 1.747L5.493 69.845c-1.345 2.33.337 5.243 3.027 5.243h72.958c2.692 0 4.373-2.913 3.028-5.243L48.027 6.66z",
  fill: "#FBAD00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.875 41.3h8.999c1.474 0 3.024 0 4.575.417 2.609.719 6.277 3.062 6.277 8.469 0 3.554-1.664 7.373-6.428 8.43-1.475.343-2.874.343-4.5.343h-3.894v9.035h-5.03V41.3zm5.029 4.273v9.265h3.592c1.059 0 1.966 0 2.835-.228 3.1-.756 3.289-3.591 3.289-4.538 0-1.965-.87-2.986-1.322-3.402-1.248-1.06-2.987-1.097-4.613-1.097h-3.781zM69.188 53.4v14.595h-4.272v-2.27c-2.382 2.346-5.067 2.949-7.298 2.949-8.242 0-12.59-6.58-12.59-13.761 0-8.394 5.557-14.293 12.892-14.293 5.56 0 9.642 3.404 11.268 7.865l-4.765 1.929c-.49-1.476-1.926-5.294-6.465-5.294-5.028 0-7.486 4.385-7.486 9.64 0 5.862 3.214 9.227 7.562 9.227 2.8 0 6.126-1.476 6.58-6.201h-6.656V53.4h11.23z",
  fill: "#FFF"
}));

function SvgRatingPg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 80"
  }, props), _ref, _ref2);
}

export default SvgRatingPg;